module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dark"
  }, [_c('section', {
    staticClass: "content-box"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeTc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6c30d2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/components/tc/Tc.vue
// module id = 696
// module chunks = 0